<template>
  <v-menu
    v-model="showMenu"
    offset-y
    bottom
    nudgeBottom="10"
    :min-width="240"
    :max-width="300"
    :max-height="350"
    transition="scale-transition"
    content-class="records-tags__content"
    :close-on-content-click="false"
  >
    <v-btn
      class="records-tags__btn"
      :class="{ selected: selectedE }"
      depressed
      color="grey lighten-3"
      slot="activator"
    >
      <SvgIcon class="tag-icon" height="20" width="20" icon="Employee" />
      {{ $t('select_employees.select_activator') }}
    </v-btn>

    <SelectEmployees
      v-if="showMenu"
      :id="selectedEmployees"
      :items="employees"
      @onChange="handleChange"
      @onClose="showMenu = false"
    />
  </v-menu>
</template>

<script>
import SelectEmployees from '@/components/records_v2/SelectEmployees'

export default {
  name: 'RecordsEmployees',
  props: {
    selectedEmployees: {
      type: Array,
      default: () => []
    },
    employees: {
      type: Array,
      default: () => []
    },
    onChange: {
      type: Function
    }
  },
  components: {
    SelectEmployees
  },
  computed: {
    selectedE() {
      if (this.selectedEmployees) {
        return this.selectedEmployees.length > 0
      } else return false
    }
  },
  data() {
    return {
      showMenu: false
    }
  },
  methods: {
    handleChange(selected) {
      this.showMenu = false
      this.$emit('onChange', selected)
    }
  }
}
</script>

<style lang="scss" scoped>
.records-tags__btn {
  border-radius: 41px;
  text-transform: none;
  font-weight: normal;

  .tag-icon {
    margin-right: 4px;
  }
}
</style>

<style lang="scss">
.records-tags__content {
  border-radius: 8px;
}

.records-tags__btn {
  &.selected {
    background-color: #7a8189 !important;
    border-color: #7a8189 !important;
    color: #fff;

    .tag-icon {
      svg {
        fill: #7a8189;

        path {
          fill: #fff;
        }
      }
    }
  }
}
</style>
